import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_2 = { id: "paper-info" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "lg:flex lg:flex-row-reverse" }
const _hoisted_5 = { class: "flex-1 lg:text-right mt-2" }
const _hoisted_6 = {
  key: 0,
  class: "italic"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("  |  ")
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "flex-1 mt-2 text-gray-500 font-semibold" }
const _hoisted_12 = {
  key: 0,
  class: "bg-amber-50 border-l-4 border-amber-400 p-4 mt-4 sm:mt-6"
}
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = { class: "flex-shrink-0" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "ml-3" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-5 text-amber-700" }, " Constructing and analyzing a graph takes time. If it's not cached it may take up to a minute for the graph to load. Please be patient. ")
], -1)
const _hoisted_16 = { class: "pt-2 sm:pt-4 lg:flex" }
const _hoisted_17 = { class: "text-xs lg:flex-none" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Links: ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_favorite_paper_button = _resolveComponent("favorite-paper-button")!
  const _component_authors = _resolveComponent("authors")!
  const _component_ExclamationIcon = _resolveComponent("ExclamationIcon")!
  const _component_PaperHeroStats = _resolveComponent("PaperHeroStats")!
  const _component_external_links = _resolveComponent("external-links")!

  return (_ctx.paper)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", null, [
            _createVNode(_component_favorite_paper_button, {
              id: _ctx.paper.id
            }, null, 8, ["id"]),
            _createElementVNode("span", {
              innerHTML: _ctx.paper.title,
              class: "pl-1"
            }, null, 8, _hoisted_3)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.paper.journal)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.paper.journal), 1))
                : _createCommentVNode("", true),
              (_ctx.paper.volume)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, ", vol " + _toDisplayString(_ctx.paper.volume), 1))
                : _createCommentVNode("", true),
              (_ctx.paper.doi)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("a", {
                      href: _ctx.paper.doi,
                      target: "_blank",
                      class: "underline"
                    }, _toDisplayString(_ctx.paper.doi.replace('https://doi.org/', '')), 9, _hoisted_10)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_authors, {
                authors: _ctx.paper.author,
                separator: ' | ',
                showAll: true,
                ids: [_ctx.paper.id]
              }, null, 8, ["authors", "ids"])
            ])
          ]),
          (!_ctx.receivedLoaded && _ctx.graphStats)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_ExclamationIcon, { class: "h-5 w-5 text-amber-400" })
                  ]),
                  _hoisted_15
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_PaperHeroStats, {
            numCitedBy: _ctx.paper.num_cited_by,
            numCiting: _ctx.paper.num_citing,
            publishedYear: _ctx.paper.published_year,
            id: _ctx.paper.id,
            doi: _ctx.paper.doi,
            graphStats: _ctx.graphStats
          }, null, 8, ["numCitedBy", "numCiting", "publishedYear", "id", "doi", "graphStats"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_external_links, { paper: _ctx.paper }, null, 8, ["paper"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}